import AccessLogs from '@/views/access-logs/AccessLogs';
import AccessLogList from '@/views/access-logs/AccessLogList';
import { dashLayout } from '../layout';
import { isLoggedIn } from '../guards';

export default [
  {
    path: '/access-logs',
    components: {
      default: AccessLogs,
      ...dashLayout,
    },
    children: [
      {
        path: '',
        name: 'AccessLogList',
        components: {
          default: AccessLogList,
        },
        beforeEnter: isLoggedIn,
      },
    ],
  },
];



// WEBPACK FOOTER //
// ./src/router/modules/access-logs.js